import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3002b440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = { class: "selection-bar cm-ui-mb15" }
const _hoisted_3 = { class: "pagination-select-count" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "dialog-footer" }

import { ref, reactive, computed, watch, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { FormType, ObjectFormItem, DateType } from '@/components/cmForm/types'
import { SoftwareInfo, InstalledDetailService, QueryParams } from './installed-detail.service'
import { formatDuration, formatTimeStamp } from '@/utils/time'
import { useParseTime } from '@/hooks'
import dayjs from 'dayjs'
import { resolveInstalledDetailDateRange } from '@/views/dashboard/manage/genuine-software-usage/_utils/installed-detail-date-range'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { ElMessage } from 'element-plus'
import { TableOpt } from '@/components/cmTable/types'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import { splitSoftHashKey } from '@/utils/tool'

export default /*#__PURE__*/_defineComponent({
  __name: 'installed-detail',
  props: {
    groupId: {},
    deviceId: {},
    computerName: {},
    date: {},
    hasPermission: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const hasPermission = computed(() => props.hasPermission)

const injector = useReflectiveInjector([InstalledDetailService])
const service = injector.get(InstalledDetailService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const selectedRows = ref<SoftwareInfo[]>([])

const data = reactive({
  uninstallDialogVisible: false,
  uninstallType: 0 as 0 | 1
})

const totalCount = computed(() => tableRef.value?.total ?? 0)

const { t, locale } = useI18n()

function rangeFromProps (): [string, string] {
  const [a, b] = resolveInstalledDetailDateRange(props.date)
  return [dayjs(a).format('YYYY-MM-DD'), dayjs(b).format('YYYY-MM-DD')]
}

function applyDateRangeToForm (range: [string, string]) {
  const [s, e] = useParseTime(range)
  form.date_range = [...range]
  if (s != null && e != null) {
    form.date = [new Date(s * 1000), new Date(e * 1000)] as [Date, Date]
    form.start_time = String(s)
    form.end_time = String(e)
  }
}

const initRange = rangeFromProps()
const [initStartSec, initEndSec] = useParseTime(initRange)

const form = reactive<{
  searchKey: string
  date_range: string[]
  date: Date[]
  device_id: string
  soft_name: string
  start_time?: string
  end_time?: string
  asc: boolean
  sort: string
  authenticsoft_flag: number
  useMemory: boolean
  page: number
  limit: number
}>({
  searchKey: '',
  date_range: [...initRange],
  date:
    initStartSec != null && initEndSec != null
      ? ([new Date(initStartSec * 1000), new Date(initEndSec * 1000)] as [Date, Date])
      : ([] as unknown as Date[]),
  device_id: props.deviceId ?? '',
  soft_name: '',
  start_time: initStartSec != null ? String(initStartSec) : undefined,
  end_time: initEndSec != null ? String(initEndSec) : undefined,
  asc: false,
  sort: 'use_soft_count',
  authenticsoft_flag: 0,
  useMemory: false,
  page: 1,
  limit: 20,
})

const filterFormColumns = computed<ObjectFormItem<typeof form, 'date_range'>>(() => {
  void locale.value
  return {
    date_range: {
      prop: 'date_range',
      label: t('genuineSoftwareUsage.timeRange'),
      type: FormType.Date,
      dateType: DateType.DateRange,
      colOpt: { style: 'flex:0 0 260px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      dateOpt: {
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('common.startDate'),
        'end-placeholder': t('common.endDate'),
        clearable: false,
      },
      events: {
        change: (val: string[]) => {
          const [start, end] = useParseTime(val)
          form.start_time = start != null ? String(start) : undefined
          form.end_time = end != null ? String(end) : undefined
          handleQuery()
        },
      },
    },
  }
})

const resolvedStartEndSec = computed(() => {
  const dr = form.date_range
  if (Array.isArray(dr) && dr.length === 2 && dr[0] && dr[1]) {
    return useParseTime([dr[0], dr[1]])
  }
  return useParseTime(rangeFromProps())
})

watch(
  () => [props.deviceId, resolvedStartEndSec.value] as const,
  () => {
    const [st, et] = resolvedStartEndSec.value
    form.device_id = props.deviceId ?? ''
    form.start_time = st != null ? String(st) : undefined
    form.end_time = et != null ? String(et) : undefined
  },
  { immediate: true }
)

function toggleSelectByMemory () {
  form.useMemory = !form.useMemory
  nextTick(() => void refreshList())
}

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
  selection: true,
  selectColumnOpt: { width: 50 },
  columns: [
    { prop: 'soft_name', label: t('genuineSoftwareUsageColumns.softName'), columnOpt: { minWidth: 140 } },
    { prop: 'soft_version', label: t('genuineSoftwareUsageColumns.version'), columnOpt: { minWidth: 130 } },
    { prop: 'auth_status', label: t('genuineSoftwareUsageColumns.authStatus'), columnOpt: { minWidth: 108 } },
    { prop: 'duration', label: t('genuineSoftwareUsageColumns.avgUseDuration'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'use_soft_count', label: t('genuineSoftwareUsageColumns.avgUseCount'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'last_active_time', label: t('genuineSoftwareUsageColumns.lastActiveTime'), columnOpt: { minWidth: 168, sortable: 'custom' }, formatter: (_row: any, value: unknown) => formatLastActiveCellValue(value) },
    { prop: 'install_time', label: t('genuineSoftwareUsageColumns.installTime'), columnOpt: { minWidth: 168, sortable: 'custom' }, formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') || '--' },
  ],
  rowKey: 'soft_hash_key',
  showActionBar: false,
  showSearch: false,
  showRightToolbar: false,
  path: 'list',
  totalPath: 'total',
  usePagination: false,
  disableScrollLoad: false,
  scrollLoadThreshold: 10,
  scrollLoadDelay: 100,
  height: '100%'
  }
})

function formatLastActiveCellValue(v: unknown) {
  if (v == null || v === '') return '--'
  if (typeof v === 'number') {
    return formatTimeStamp(String(v), 'YYYY-MM-DD HH:mm') || '--'
  }
  if (typeof v === 'string' && /^\d+$/.test(v.trim())) {
    return formatTimeStamp(v, 'YYYY-MM-DD HH:mm') || '--'
  }
  return String(v)
}

function formatDurationSlot(slotProps: Record<string, unknown>) {
  const row = slotProps?.row as SoftwareInfo | undefined
  return row ? formatDuration(row.duration * 60) || '--' : '--'
}

function authStatusOf(slotProps: Record<string, unknown>) {
  return (slotProps?.row as SoftwareInfo | undefined)?.auth_status
}

function authStatusTagType(s: number): 'info' | 'success' | 'warning' | 'danger' {
  const map: Record<number, 'info' | 'success' | 'warning' | 'danger'> = {
    0: 'danger',
    1: 'warning',
    2: 'success',
    3: 'info',
  }
  return map[s] ?? 'info'
}

function authStatusLabel(s: number) {
  const keys = [
    'genuineSoftwareUsageColumns.authStatus0',
    'genuineSoftwareUsageColumns.authStatus1',
    'genuineSoftwareUsageColumns.authStatus2',
    'genuineSoftwareUsageColumns.authStatus3',
  ] as const
  return keys[s] != null ? t(keys[s]) : '--'
}

function getListApi(params: any) {
  if (!hasPermission.value) {
    return Promise.resolve({ list: [], total: 0 })
  }
  const raw = params ?? {}
  const p: Partial<QueryParams> = {
    device_id: form.device_id,
    soft_name: form.searchKey,
    start_time: form.start_time,
    end_time: form.end_time,
    asc: raw.asc ?? form.asc ?? false,
    sort: raw.sort ?? form.sort ?? 'use_soft_count',
    authenticsoft_flag: form.authenticsoft_flag,
    useMemory: form.useMemory,
    limit: raw.limit ?? form.limit ?? 20,
    page: raw.page ?? form.page ?? 1,
  }
  return service.getListByServer(p)
}

function handleSearch (value: string) {
  form.searchKey = value
  nextTick(() => void refreshList())
}

function handleQuery () {
  nextTick(() => void refreshList())
}

function handleFilterReset () {
  form.searchKey = ''
  applyDateRangeToForm(rangeFromProps())
  nextTick(() => void refreshList())
}

function handleSelectionChange(selection: SoftwareInfo[]) {
  selectedRows.value = selection
}

function showUninstallDialog() {
  if (!hasPermission.value) return
  data.uninstallDialogVisible = true
  data.uninstallType = 0
}

function resetRadio() {
  data.uninstallType = 0
  data.uninstallDialogVisible = false
}

function uninstallSoftware() {
  if (!hasPermission.value) return
  data.uninstallDialogVisible = false
  const soft_hash_keys = selectedRows.value.map(item => splitSoftHashKey(item.soft_hash_key))
  if (soft_hash_keys.length === 0) return
  service.uninstallSoftware({
    uninstall_type: data.uninstallType,
    device_id: props.deviceId!,
    soft_hash_keys: soft_hash_keys.flat(5)
  }).then(() => {
    ElMessage.success(t('genuineSoftwareUsage.uninstallSuccessTip', { count: selectedRows.value.length }))
    selectedRows.value = []
    tableRef.value?.tableRef?.clearSelection?.()
    void refreshList()
  }).catch(() => {
    ElMessage.error(t('genuineSoftwareUsage.uninstallFailedTip'))
  })
}

function download(type: 0 | 1) {
  if (!hasPermission.value) return
  const [st, et] = resolvedStartEndSec.value
  const q: QueryParams = {
    limit: 20,
    page: 1,
    device_id: props.deviceId ?? '',
    start_time: st != null ? String(st) : undefined,
    end_time: et != null ? String(et) : undefined,
    soft_name: form.searchKey,
    useMemory: false,
    asc: false,
    sort: 'use_soft_count',
    authenticsoft_flag: 0
  }
  service.download(type, q, t('softwareManage.exportTerminalView') + t('genuineSoftwareUsage.exportTerminalUsedSoft', { name: props.computerName }))
}

watch(
  () => props.deviceId,
  (id, prev) => {
    if (id && id !== prev) {
      applyDateRangeToForm(rangeFromProps())
    }
    nextTick(() => void refreshList())
  },
)

watch(
  () => props.date,
  () => {
    applyDateRangeToForm(rangeFromProps())
    nextTick(() => void refreshList())
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "table-opt": tableOpt.value,
      api: getListApi,
      modelValue: form,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
      "page-option": pageOption,
      "has-permission": hasPermission.value,
      onChangeSelected: handleSelectionChange
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !hasPermission.value,
          "show-search": true,
          "search-placeholder": _ctx.$t('genuineSoftwareUsage.searchPlaceholderSoftware'),
          "popover-threshold": 0,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleFilterReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              disabled: selectedRows.value.length === 0 || !hasPermission.value,
              type: "primary",
              size: "small",
              onClick: showUninstallDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstall')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(ExportDropdown, {
              "has-permission": hasPermission.value,
              onExport: download
            }, null, 8, ["has-permission"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectedSoftPrefix')) + " ", 1),
            _createElementVNode("a", {
              onClick: toggleSelectByMemory,
              class: _normalizeClass(form.useMemory ? 'req-default' : 'req-primary')
            }, _toDisplayString(selectedRows.value.length), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('genuineSoftwareUsage.selectedSoftSuffix')), 1)
          ])
        ])
      ]),
      auth_status: _withCtx((slotProps) => [
        (authStatusOf(slotProps) !== undefined && authStatusOf(slotProps) !== null)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "small",
              type: authStatusTagType(authStatusOf(slotProps)!)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(authStatusLabel(authStatusOf(slotProps)!)), 1)
              ]),
              _: 2
            }, 1032, ["type"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
      ]),
      duration: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(formatDurationSlot(slotProps)), 1)
      ]),
      _: 1
    }, 8, ["table-opt", "modelValue", "has-permission"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.$t('genuineSoftwareUsage.uninstallDialogTitle'),
      modelValue: data.uninstallDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.uninstallDialogVisible) = $event)),
      width: "30%",
      "before-close": resetRadio,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: uninstallSoftware
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            modelValue: data.uninstallType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.uninstallType) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { label: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeNotify')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeSilent')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})